angular.module('bribac.components.mainGroupSubGroupPicker', [
    'ngRoute',
    'ui.bootstrap',
    'bribac.translations',
    'bribac.values',
    'bribac.services.api',
    'bribac.components.whenLoaded',
])
.component('mainGroupSubGroupPicker', {
    templateUrl: 'main-group-subgroup-picker-component.html',
    controller: 'MainGroupSubGroupPickerCtrl',
    bindings: {
        mainGroups: '=',
        selectedGroups: '='
    }
})
.controller('MainGroupSubGroupPickerCtrl', function () {
    // Init
    var $ctrl = this
    $ctrl.toggleSubGroup = function (subGroupToToggle) {
        if ($ctrl.selectedGroups.findIndex(function (obj) { return subGroupToToggle.id === obj.id }) > -1) {
            subGroupToToggle.isChecked = false
            $ctrl.selectedGroups = $ctrl.selectedGroups.filter(function (subGroup) {
                return subGroup.id !== subGroupToToggle.id
            })
        } else {
            subGroupToToggle.isChecked = true
            $ctrl.selectedGroups.push(subGroupToToggle)
        }
        var mg = $ctrl.mainGroups.find(function(item) {
            return subGroupToToggle.mainGroup.id === item.id
        })
        mg.isChecked = mg.subGroups.every(function (subGroup) {
            return subGroup.isChecked
        })
    }

    $ctrl.toggleMainGroup = function (mainGroupToToggle) {
        mainGroupToToggle.isChecked = !mainGroupToToggle.isChecked
        angular.forEach(mainGroupToToggle.subGroups, function (subGroup, index) {
            if (mainGroupToToggle.isChecked) {
                subGroup.isChecked = true
                if ($ctrl.selectedGroups.indexOf(subGroup) === -1) {
                    $ctrl.selectedGroups.push(subGroup)
                }
            } else {
                subGroup.isChecked = false
                $ctrl.selectedGroups = $ctrl.selectedGroups.filter(function (subGroupToFilter) {
                    return subGroupToFilter.id !== subGroup.id
                })
            }
        })
    }
})
